<ng-container *ngIf="activeType">
  <div
    *ngIf="onboardingMode"
    class="onboarding__intro"
    fxLayoutGap="24px"
    fxLayoutAlign="start center"
    [ngStyle.lt-lg]="{ padding: '12px' }">
    <div fxHide.lt-lg fxFlex="170px" class="onboarding__left">
      <img [src]="property.picture" width="170" height="120" />
    </div>
    <div class="onboarding__right">
      <h3>Onboarding assistant for {{ property.name }}</h3>
      <div>
        Onboarding assistant shows you all your available rules, teammates and custom codes in one place. Click on +Add
        to add the property to the scope of an existing rule, teammate or custom code.
      </div>
    </div>
  </div>

  <div class="rules__filters-container" fxLayout fxLayout.lt-lg="column" fxLayoutGap="16px">
    <div fxFlex>
      <sbnb-filter
        *ngIf="this.activeType?.filterId"
        #filterComponent
        [componentName]="this.activeType.filterId"
        [hideSaveSegment]="true"
        [defaultFilters]="activeFilters"
        (filterChanged)="handleFilterChanged($event)"
        (reset)="filterReset()"></sbnb-filter>
    </div>
    <sbnb-search-bar
      #searchComponent
      style="height: 32px"
      placeholderText="Search..."
      [initialVal]="searchCriteria"
      (searchChanged)="searchUpdated($event)"></sbnb-search-bar>
    <button
      *ngIf="!onboardingMode"
      class="button__small"
      mat-flat-button
      [ngClass.lt-lg]="{ push__right: true }"
      (click)="enableOnboarding()">
      Onboarding assistant
    </button>
  </div>

  <mat-spinner *ngIf="loading" [diameter]="16"></mat-spinner>

  <ng-container *ngIf="!loading">
    <div *ngIf="tableData && tableData.length === 0 && !onboardingMode" class="no__items">
      <div class="no__items-header">No {{ activeType.label | lowercase }} found</div>
      <div class="no__items-body">
        There are no {{ activeType.label | lowercase }} scoped for this property yet but don't worry.
        <br />
        You can manually select from existing {{ activeType.label | lowercase }} you want to add.
      </div>
      <div>
        <button class="button__small" mat-flat-button (click)="enableOnboarding()">Onboarding assistant</button>
      </div>
    </div>

    <div *ngIf="tableData && tableData.length === 0 && onboardingMode" class="no__items">
      <div class="no__items-header">
        No {{ activeType.label | lowercase }} available to associate with this property
      </div>
    </div>

    <div *ngIf="tableData && tableData.length > 0" fxLayout fxLayoutGap="18px" fxHide.lt-lg class="rules__rule-header">
      <div fxFlex="80px">Status</div>
      <div *ngFor="let col of activeType.columns" [fxFlex]="col.flex">
        {{ col.label }}
      </div>
    </div>

    <div
      *ngFor="let row of tableData"
      fxLayout
      fxLayoutGap="18px"
      fxLayoutAlign="start center"
      class="rules__rule-container">
      <div fxFlex="80px">
        <mat-spinner *ngIf="row.deleting || row.adding" [diameter]="16"></mat-spinner>

        <ng-container *ngIf="!row.deleting && !row.adding">
          <div
            *ngIf="(!onboardingMode && !row.deleted) || row.added"
            class="scoped__btn"
            (click)="removePropertyFromRule(row)"></div>
          <div
            *ngIf="(onboardingMode && !row.added) || row.deleted"
            class="scoped__add"
            (click)="addPropertyToRule(row)">
            + Add
          </div>
        </ng-container>
      </div>

      <ng-container
        *ngIf="
          activeType.id === 'messaging-rules' ||
          activeType.id === 'review-rules' ||
          activeType.id === 'canned-responses' ||
          activeType.id === 'notification-rules' ||
          activeType.id === 'custom-codes'
        ">
        <a
          *ngIf="activeType.id !== 'custom-codes'"
          class="strong clickable ellipsis"
          [class.rule__inactive]="row.active === false"
          [fxFlex]="activeType.columns[0].flex"
          [routerLink]="[activeType.url + row.id]"
          target="_blank"
          [matTooltip]="row.rule_preview ? row.rule_preview.substring(0, 100) + '...' : ''">
          {{ row.name }}
        </a>

        <a
          *ngIf="activeType.id === 'custom-codes'"
          class="strong clickable ellipsis"
          [class.rule__inactive]="row.active === false"
          [fxFlex]="activeType.columns[0].flex"
          [routerLink]="[activeType.url + row.id]"
          target="_blank">
          {{ row.key }}
        </a>

        <div
          *ngIf="activeType.id !== 'canned-responses' && activeType.id !== 'custom-codes'"
          fxHide.lt-lg
          class="text__small"
          [class.rule__inactive]="row.active === false"
          [fxFlex]="activeType.columns[1].flex">
          {{ row.event_short }}
        </div>

        <div
          *ngIf="activeType.id === 'canned-responses'"
          class="text__small ellipsis"
          [class.rule__inactive]="row.active === false"
          [fxFlex]="activeType.columns[1].flex"
          fxHide.lt-lg>
          {{ row.rule_preview }}
        </div>

        <div
          *ngIf="activeType.id === 'custom-codes'"
          class="text__small ellipsis"
          [class.rule__inactive]="row.active === false"
          [fxFlex]="activeType.columns[1].flex"
          fxHide.lt-lg>
          <span *ngIf="!row.all_conditions" class="text__small ellipsis" fxFlex>
            {{ row.condition | conditionToText: conditions }}
          </span>
          <span *ngIf="row.all_conditions" class="text__small ellipsis" fxFlex>
            No condition - include all the time
          </span>
        </div>

        <div [fxFlex]="activeType.columns[2].flex" fxHide.lt-lg>
          <sbnb-hosts [allHosts]="row.all_hosts" [hosts]="row.host_list" [ruleName]="row.name"></sbnb-hosts>
        </div>

        <div [fxFlex]="activeType.columns[3].flex">
          <sbnb-avatar-group
            [items]="row.property_list"
            [allItems]="row.all_properties"
            [itemsForLabel]="row.name"></sbnb-avatar-group>
        </div>

        <div *ngIf="activeType.columns[4]" [fxFlex]="activeType.columns[4].flex" fxHide.lt-lg>
          <sbnb-scoping-icons
            class="hidden md:flex"
            [showTooltips]="false"
            [scoped]="[
              (row | doesRuleHavePlatform: 'direct') ||
              (row | doesRuleHavePlatform: 'manual') ||
              (row | doesRuleHavePlatform: 'gvr')
                ? 'hospitable'
                : null,
              (row | doesRuleHavePlatform: 'airbnb') ? 'airbnb' : null,
              (row | doesRuleHavePlatform: 'homeaway') ? 'homeaway' : null,
              (row | doesRuleHavePlatform: 'booking') ? 'booking' : null
            ]"></sbnb-scoping-icons>
        </div>
      </ng-container>

      <ng-container *ngIf="activeType.id === 'task-rules'">
        <a
          class="strong clickable"
          [routerLink]="[activeType.url + row.uuid]"
          [class.rule__inactive]="row.active === false"
          target="_blank"
          [fxFlex]="activeType.columns[0].flex">
          {{ row.name }}
        </a>

        <div class="text__small" fxHide.lt-lg [fxFlex]="activeType.columns[1].flex">
          {{ row.timing.unit.value ? row.timing.unit.value : 'Immediately' }}{{ row.timing.unit.value_append }}
          {{ row.timing.when }}
          <strong>{{ row.relative_to }}</strong>
        </div>

        <div [fxFlex]="activeType.columns[2].flex">
          <sbnb-avatar-group
            [items]="row.property_list"
            [allItems]="row.all_properties"
            [itemsForLabel]="row.name"></sbnb-avatar-group>
        </div>

        <div [fxFlex]="activeType.columns[3].flex" fxLayoutAlign="start center" fxLayoutGap="8px" fxHide.lt-lg>
          <sbnb-team-icon *ngIf="row.teammate" fxFlex="32px" [member]="row.teammate"></sbnb-team-icon>

          <span *ngIf="!row.teammate_name" class="text__small manual">Manual</span>
        </div>
      </ng-container>

      <ng-container *ngIf="activeType.id === 'team'">
        <a
          class="strong clickable"
          [routerLink]="[activeType.url + row.uuid]"
          target="_blank"
          [fxFlex]="activeType.columns[0].flex"
          fxLayoutGap="8px">
          <span>{{ row.name }}</span>
          <sbnb-team-role-badge *ngIf="row.services_labels" fxHide.lt-md [member]="row"></sbnb-team-role-badge>
        </a>

        <div class="text__small" fxHide.lt-lg [fxFlex]="activeType.columns[1].flex">
          {{ row.company_name ? row.company_name : 'Individual' }}
        </div>

        <div class="text__small" fxHide.lt-lg [fxFlex]="activeType.columns[2].flex">
          {{ row.address.country ? row.address.city + ' ' + row.address.country : 'Unknown' }}
        </div>

        <div class="text__small" [fxFlex]="activeType.columns[3].flex">
          <sbnb-avatar-group
            [items]="row.property_list"
            [allItems]="row.all_properties"
            [itemsForLabel]="row.name"></sbnb-avatar-group>
        </div>
      </ng-container>
    </div>

    <sbnb-pagination
      *ngIf="paginationData && paginationData.page_numbers.total_pages > 1"
      position="end"
      [pageCount]="paginationData.page_numbers.total_pages"
      [currentPage]="paginationData.page_numbers.this_page"
      (pageChanged)="handlePageChanged($event)"></sbnb-pagination>
  </ng-container>
</ng-container>
